import React, { useCallback, useRef, useState } from "react";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import PlusButtonIcon from "../../../../../../assets/images/PlusButtonIcon.svg";
import ModalDelete from "../../../../../../components/ModalDelete";
import Loading from "../../../../../../core/common/Loading";
import Grid from "../../../../../../components/Grid";
import { GridHandle } from "../../../../../../components/Grid/model/Grid";
import {
  formatDateTimeBR
} from "../../../../../../helpers/format";
import CustomModal from "../../../../../../components/CustomModal";
import api from "../../../../../../services/api";
import { ITransportadorasVeiculos } from "./types/types";
import { ITransportadoras } from "../../types/types";
import Create from "./Create";

import { FrontendNotification } from "../../../../../../shared/Notification";
import { toast } from "sonner"
import Info from "./Info";
import { useAuth } from "../../../../../../hooks/AuthenticateContext";

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: ITransportadoras;
}

const TransportadorasVeiculos: React.FC<Props> = (props: Props) => {
  const [selectedRow, setSelectedRow] = useState<ITransportadorasVeiculos>();
  const [isView, setIsView] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const { user } = useAuth();

  const defaultColumns = [
    {
      field: "placa_dianteira_veiculo",
      fieldName: "placa_dianteira_veiculo",
      headerName: "Placa Dianteira",
      filter: true,
      valueFormatter: (params: any) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: any) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data do Histórico",
      flex: 1,
      valueFormatter: (params: any) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }

        return "---";
      },
    },
  ];

  const gridRef = useRef<GridHandle>(null);

  const defaultFilters = {
    id_transportadora: props.selectedRow?.id_transportadora,
  }

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);

      const body = {
        id_transportadora_veiculo: rowId,
        id_usuario_historico: user?.id,
      };

      console.log("Passou", body);

      toast.success("Veiculo removido com sucesso!")

      await api.post("/deletar/transportadorasVeiculos", body);

      FrontendNotification("Veiculo removido com sucesso!", "success")

      setLoading(false);

      gridRef.current?.api?.refreshCells({
        force: true,
      })

    } catch {
      setLoading(false);
    }
  }, [user]);

  return (
    <CustomModal
      title="Transportadoras Veiculos"
      isScreenLg
      onClose={props.onClear}
    >
      <div className="overflow-y-scroll max-w-full min-h-[600px] p-2 mb-5">
        <Loading loading={loading} skeletonVariant="grid" skeletonRows={6} skeletonColumns={3} skeletonFooterButtons={0} />

        {showCreate && (
          <Create
            isEdit={isEdit}
            isView={isView}
            selectedRow={selectedRow}
            onClear={() => {
              setShowCreate(!showCreate);
              setIsEdit(false);
              setSelectedRow(undefined);
            }}
            onConfirm={() => {
              setShowCreate(!showCreate)
              gridRef.current?.api?.refreshCells({
                force: true,
              })
            }}
            id_transportadora={props.selectedRow?.id_transportadora}
          />
        )}
        {isRemove && (
          <ModalDelete
            isOpen={isRemove}
            title="Deseja desativar o veiculo?"
            message="Por favor, confirme que você deseja desativar o veiculo dessa transportadora:"
            onCancel={() => setIsRemove(!isRemove)}
            onConfirm={() => {
              setIsRemove(!isRemove)
              onDelete(selectedRow?.id_transportadora_veiculo)
            }}
            row={String(selectedRow?.placa_dianteira_veiculo)}
          />
        )}
        {isView && (
          <Info
            data={selectedRow}
            title="Conhecer - Transportadoras Veículos"
            onClose={() => setIsView(!isView)}
          />
        )}
        <div className="w-full flex justify-end mr-6">
          <button
            className="flex items-center justify-center h-10 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full mr-8"
            onClick={() => setShowCreate(!showCreate)}
          >
            Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
          </button>
        </div>
        <div className="ag-theme-quartz max-h-32 mt-4">
          <Grid
            ref={gridRef}
            isModal
            columns={defaultColumns}
            filters={[]}
            customFilters={defaultFilters}
            pagination
            path="/listar/transportadorasVeiculos"
            onDelete={(data: ITransportadorasVeiculos) => {
              setIsRemove(!isRemove);
              setSelectedRow(data);
            }}
            status={[]}

            onView={(data: ITransportadorasVeiculos) => {
              setSelectedRow(data);
              setIsView(!isView);
            }}
            onUpdate={(data: ITransportadorasVeiculos) => {
              setSelectedRow(data);
              setIsEdit(!isEdit);
              setShowCreate(!showCreate);
            }}
          />
        </div>
      </div>
    </CustomModal>
  );

};
export default TransportadorasVeiculos;
